import PropTypes from 'prop-types';
import { FormControl, RadioGroup, FormControlLabel, Typography, Radio, FormLabel, Stack } from '@mui/material';
import { Controller } from 'react-hook-form';
import { FieldError } from 'components/common/form/FieldError';

export const VariantField = (props) => {
  const {
    id = 'options-controlled-radio-buttons-group',
    name = 'controlled-radio-buttons-group',
    label = 'Options',
    error = '',
    control = () => {},
    options = () => [],
    valueName = 'price',
    optionName = 'name',
    optionPrice = 'price',
  } = props;

  return (
    <>
      <FormControl>
        <FormLabel
          id={id}
          sx={{ fontWeight: 500 }}
        >
          {label}
        </FormLabel>
        <Controller
          name={name}
          control={control}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <RadioGroup
              aria-labelledby={id}
              name={name}
              value={value}
              onChange={(event) => {
                onChange(event.target.value);
              }}
            >
              {options.map((option, index) => (
                <FormControlLabel
                  key={`${option[id]}-${index}`}
                  value={option[valueName]}
                  control={<Radio size="small" />}
                  label={
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={1}
                    >
                      <Typography
                        component="h2"
                        variant="subtitle2"
                        sx={{
                          fontWeight: 400,
                          minWidth: '180px',
                          width: '180px',
                          maxWidth: '180px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {option[optionName]}
                      </Typography>
                      <span style={{ textAlign: 'center' }}>-</span>
                      <Typography
                        component="h2"
                        variant="subtitle2"
                        sx={{
                          fontWeight: 400,
                          minWidth: '70px',
                          width: '70px',
                          maxWidth: '180px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          textAlign: 'right',
                        }}
                      >
                        ${Number(option[optionPrice] || 0).toFixed(2)}
                      </Typography>
                    </Stack>
                  }
                />
              ))}
            </RadioGroup>
          )}
        />
      </FormControl>
      {error && <FieldError message={error} />}
    </>
  );
};

VariantField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  hasError: PropTypes.bool,
  error: PropTypes.string,
  control: PropTypes.object.isRequired,
  options: PropTypes.array,
  valueName: PropTypes.string,
  optionName: PropTypes.string,
  optionPrice: PropTypes.string,
};
